<template>
  <v-container>
    <v-row justify="start" no-gutters class="my-2">
      <v-btn exact text :to="{ name: prevRoute }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <v-card class="mb-2">
      <v-card-text>
        <PreparationSlipFields
          :date.sync="date"
          :time.sync="timeValue"
          v-bind.sync="preparationSlip"
          :valid.sync="valid"
        ></PreparationSlipFields>
        <v-row dense>
          <v-col cols="12">
            <PreparationSlipTemplateSelector
              v-model="preparationSlipTemplateId"
            ></PreparationSlipTemplateSelector>
          </v-col>
        </v-row>
        <v-row v-show="showSalesTarget" dense class="mt-2">
          <v-col cols="12" sm="6" md="4">
            <j-decimal-input
              dense
              filled
              class="no-before"
              suffix="$"
              label="Montant des ventes estimé pour ce gabarit"
              hide-details
              persistent-hint
              :value="sales_target_value"
              @input="v => (sales_target_value = v > 0 ? v : null)"
            ></j-decimal-input>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <section v-if="preparationSlipTemplate">
      <v-card class="mb-2">
        <v-card-text>
          <PreparationSlipEditorGrid
            :items="products"
            @update="v => getQuantityToProduce(v)"
          ></PreparationSlipEditorGrid>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <v-textarea
            filled
            class="no-before"
            hide-details
            v-model="preparationSlip.comments"
            label="Commentaires supplémentaires"
          ></v-textarea>
        </v-card-text>
      </v-card>
      <v-row align="center" justify="end" no-gutters class="mt-3">
        <v-btn
          color="success"
          @click="savePreparationSlip"
          :disabled="!valid || runningTasks.length !== 0"
          :block="$vuetify.breakpoint.xsOnly"
          :large="$vuetify.breakpoint.smAndDown"
          :loading="runningTasks.length !== 0"
        >
          <v-icon small left>fa-save</v-icon>
          Enregistrer et appliquer à l'inventaire
        </v-btn>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { round10 } from "round10";
import { mappers } from "@/mappers";
import {
  PreparationSlipTemplateSelector,
  PreparationSlipEditorGrid,
  PreparationSlipFields
} from "../components";
import moment from "moment";
export default {
  name: "PreparationSlipEditor",
  props: {
    id: {
      required: false,
      default: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from.name;
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  components: {
    PreparationSlipTemplateSelector,
    PreparationSlipEditorGrid,
    PreparationSlipFields
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getIsAdmin",
      "getProducts",
      "getRecipes",
      "getInventoryRecords",
      "getInventoryTemplates",
      "getPreparationSlipTemplates",
      "getAutomaticPreparationSlipTemplates",
      "getScheduledPreparations",
      "getDayChoices",
      "getDefaultDailySetting",
      "getSalesEstimates"
    ]),
    getNbPrimaryProductAlerts() {
      let nbAlerts = 0;
      this.products
        .filter(x => x.is_deleted === false && x.est_intermediaire === false)
        .forEach(x => {
          if (x.difference < 0) {
            nbAlerts += 1;
          }
        });
      return nbAlerts > 0 ? nbAlerts : null;
    },
    getCurrentDay() {
      return this.getDayChoices.find(
        x => x.jsValue === moment(this.date).day()
      );
    },
    getSaleEstimate() {
      if (this.timeValue === 2) {
        const saleEstimate = this.getSalesEstimates.find(
          x =>
            x.date ===
            moment(this.date)
              .add(1, "d")
              .format("YYYY-MM-DD")
        );
        return saleEstimate;
      } else {
        const saleEstimate = this.getSalesEstimates.find(
          x => x.date === this.date
        );
        return saleEstimate;
      }
    }
  },
  data() {
    return {
      prevRoute: "PreparationSlipIndex",
      preparationSlipTemplateId: null,
      preparationSlipTemplate: undefined,
      preparationSlip: {
        name: "",
        author: "",
        comments: "",
        store: null,
        is_deleted: false,
        sales_target: null
      },
      sales_target_value: null,
      showSalesTarget: false,
      preventSalesTrigger: false,
      date: moment().format("YYYY-MM-DD"),
      time: null,
      timeValue: 0,
      timeSelections: [
        {
          value: 0,
          text: "Matin",
          treshold: 11
        },
        {
          value: 1,
          text: "Midi",
          treshold: 16
        },
        {
          value: 2,
          text: "Soir",
          treshold: null
        }
      ],
      tabs: 0,
      valid: false,
      products: [],
      alerts: 0,
      automaticPreparations: [],
      scheduledPreprations: [],
      runningTasks: [],
      taskId: 0
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await this.$store.dispatch("loadExpirations");
        await Promise.all([
          this.$store.dispatch("loadSalesEstimates"),
          this.$store.dispatch("loadPreparationSlipTemplates"),
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          }),
          this.$store.dispatch("loadDefaultDailySetting"),
          this.$store.dispatch("loadAllRecipeStore"),
          this.$store.dispatch("loadAutomaticPreparationSlipTemplates"),
          this.$store.dispatch("loadScheduledPreparations")
        ]);
        this.automaticPreparations = this.getAutomaticPreparationSlipTemplates.filter(
          x => x.day === this.getCurrentDay.value
        );
        this.scheduledPreprations = this.getScheduledPreparations.filter(x =>
          moment(this.date).isSame(x.date, "day")
        );

        const time = moment();
        if (time.hours() < 11) {
          this.timeValue = 0;
        } else if (time.hours() >= 16) {
          this.timeValue = 2;
        } else {
          this.timeValue = 1;
        }
        if (this.getSaleEstimate !== undefined) {
          this.sales_target_value = Number(this.getSaleEstimate.value);
        }
        this.setTemplateFromDefault();
        if (this.id !== null) {
          this.preparationSlip = await api.retrievePreparationSlip(this.id);
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    setTemplateFromDefault() {
      if (this.getDefaultDailySetting.length > 0) {
        const defaultSetting = this.getDefaultDailySetting.find(
          x => x.period === this.timeValue
        );
        const defaultTemplate = defaultSetting
          ? defaultSetting[this.getCurrentDay.dbText]
          : undefined;
        if (defaultTemplate !== undefined) {
          if (
            this.preparationSlipTemplateId === defaultTemplate &&
            this.getSaleEstimate !== undefined
          ) {
            this.sales_target_value = Number(this.getSaleEstimate.value);
          }
          this.preparationSlipTemplateId = defaultTemplate;
        } else {
          this.preparationSlipTemplateId = null;
        }
      }
    },
    async savePreparationSlip() {
      if (this.id === null) {
        //create
        try {
          this.$store.dispatch("slo");

          //inventory record
          const prepSlipProducts = [];
          const schTasks = [];
          const invTasks = [];
          this.products.forEach(x => {
            const scheduledPreprationToUpdate = this.scheduledPreprations.filter(
              p => p.fk_product === x.id
            );
            scheduledPreprationToUpdate.forEach(s => {
              const sData = {
                ...s,
                is_done: true
              };
              schTasks.push(
                this.$store.dispatch("updateScheduledPreparation", sData)
              );
            });
            if (x.quantity_inventory !== x.origin_quantity_inventory) {
              const iData = {
                fk_product: x.id,
                store: this.getStoreId,
                date: moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
                quantity: x.quantity_inventory,
                is_deleted: false
              };
              invTasks.push(api.postInventoryRecord(iData));
            }
            const qty_to_produce =
              x.quantity_to_produce !== null ? x.quantity_to_produce : 0;
            if (x.quantity_to_produce > 0) {
              const d = {
                fk_product: x.id,
                store: this.getStoreId,
                quantity: round10(qty_to_produce, -6),
                quantity_inventory: round10(x.quantity_inventory, -6)
              };
              prepSlipProducts.push(d);
            }
          });
          const date = moment(this.date);
          const data = {
            ...this.preparationSlip,
            sales_target: this.sales_target_value,
            fk_preparation_slip_template: this.preparationSlipTemplateId,
            store: this.getStoreId,
            date: moment()
              .year(date.year())
              .month(date.month())
              .date(date.date())
              .hour(this.getProdHour())
              .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
            preparation_slip_products: prepSlipProducts
          };
          await Promise.all(invTasks, schTasks);
          const res = await api.postPreparationSlip(data);
          this.$router.push({
            name: "PreparationSlipViewer",
            params: { id: res.id }
          });
        } catch {
          this.$router.push({ name: this.prevRoute });
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    getProdHour() {
      const currentHour = moment().hour();
      const currentTimeTreshold = this.timeSelections.find(
        x => x.value === this.timeValue
      ).treshold;
      if (currentTimeTreshold !== null) {
        return currentHour > currentTimeTreshold
          ? currentTimeTreshold
          : currentHour;
      } else {
        return currentHour;
      }
    },
    async preparationSlipTemplateHandler() {
      if (this.preparationSlipTemplate === undefined) {
        this.products = [];
        return;
      }
      this.$store.dispatch("slo");
      await setTimeout(async () => {
        this.products = [
          ...this.preparationSlipTemplate.preparation_slip_template_products
        ]
          .map(x => {
            const originProduct = this.getProducts.find(
              p => p.id === x.fk_product
            );
            if (originProduct) {
              const invQty = this.getInventoryQuantity(x.fk_product);
              let askedQty = Number(x.quantity);
              if (
                askedQty >= 0 &&
                x.quantity_min > 0 &&
                this.sales_target_value !== null &&
                this.preparationSlipTemplate.sales_target !== null &&
                this.preparationSlipTemplate.sales_target !== 0
              ) {
                askedQty = round10(
                  askedQty *
                    (this.sales_target_value /
                      this.preparationSlipTemplate.sales_target),
                  -2
                );
                if (askedQty < x.quantity_min) {
                  askedQty = Number(x.quantity_min);
                }
              }
              return {
                ...originProduct,
                name: originProduct.nom,
                quantity_asked: askedQty,
                quantity_inventory: invQty,
                quantity_required: 0,
                quantity_required_recipe: 0,
                quantity_to_produce: 0, //elle a saver
                origin_quantity_asked: askedQty,
                origin_quantity_to_produce: askedQty - invQty,
                origin_quantity_inventory: invQty,
                quantity_to_add: 0,
                can_be_produce: true,
                requirements: [],
                force_show: false
              };
            } else {
              return null;
            }
          })
          .filter(x => x !== null);
        const productNotInTemplate = this.getProducts.filter(
          x => this.products.find(p => p.id === x.id) === undefined
        );
        productNotInTemplate.forEach(x => {
          let askedQty = Number(0);
          if (
            askedQty > 0 &&
            this.sales_target_value !== null &&
            this.preparationSlipTemplate.sales_target !== null &&
            this.preparationSlipTemplate.sales_target !== 0
          ) {
            askedQty = round10(
              askedQty *
                (this.sales_target_value /
                  this.preparationSlipTemplate.sales_target),
              -2
            );
            if (askedQty < x.quantity_min) {
              askedQty = Number(x.quantity_min);
            }
          }
          const invQty = this.getInventoryQuantity(x.id);
          const d = {
            ...x,
            name: x.nom,
            quantity_asked: askedQty,
            quantity_inventory: invQty,
            quantity_required: 0,
            quantity_required_recipe: 0,
            quantity_to_produce: 0, //elle a saver
            quantity_to_add: 0,
            origin_quantity_asked: askedQty,
            origin_quantity_to_produce: askedQty - invQty,
            origin_quantity_inventory: invQty,
            can_be_produce: true,
            requirements: [],
            force_show: false
          };
          this.products.push(d);
        });
        this.products.map(p => this.getQuantityToProduce(p));
        this.$store.dispatch("elo");
      }, 500);
    },
    setQuantityToProduce(item) {
      const qty = item.quantity_asked + item.quantity_to_add;
      let qtyNeeded = item.quantity_asked - item.quantity_inventory;
      if (qtyNeeded < 0) qtyNeeded = 0;
      const qty_to_product = qtyNeeded + item.quantity_to_add;
      if (qty > 0) {
        const recipe = this.getRecipes.find(
          x => x.fk_produit_intermediaire === item.id
        );
        if (recipe && recipe.always_produce_quantity) {
          let qty_to_produce_in_prod_unit = qty_to_product;
          if (recipe.data.use_conversion_formula) {
            qty_to_produce_in_prod_unit = mappers.recipeInvToProd(
              qty_to_product,
              recipe,
              recipe.data
            );
          }
          const ceil_number_of_recipe = Math.ceil(
            qty_to_produce_in_prod_unit / recipe.quantite_produite
          );
          let value = ceil_number_of_recipe * recipe.quantite_produite;
          if (recipe.data.use_conversion_formula) {
            value = mappers.recipeProdToInv(
              ceil_number_of_recipe * recipe.quantite_produite,
              recipe,
              recipe.data
            );
          }
          return round10(value, -2);
        } else {
          return qty_to_product > 0
            ? mappers.isCustomUnit(item.data.unite_mesure_inventory)
              ? Math.ceil(qty_to_product)
              : round10(qty_to_product, -2)
            : 0;
        }
      } else {
        return 0;
      }
    },
    async getItemProductionRequirements(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      const requirements = {
        can_be_produce: true,
        requirements: []
      };
      if (recipe) {
        let recipe_qty = item.quantity_to_produce;
        if (recipe.data.use_conversion_formula === true) {
          recipe_qty = mappers.recipeInvToProd(
            item.quantity_to_produce,
            recipe,
            recipe.data
          );
        }
        recipe_qty = recipe_qty / recipe.quantite_produite;
        recipe.ingredients.forEach(ingredient => {
          const raw_ingredient_quantity =
            Number(ingredient.quantite) * recipe_qty;
          const ingredientProduct = this.getProducts.find(
            p => p.id === ingredient.pk_recette_produit
          );
          let ingredient_quantity = raw_ingredient_quantity;
          if (ingredientProduct) {
            if (ingredientProduct.data.use_conversion_formula) {
              if (ingredient.is_alternative_unite_mesure === true) {
                if (
                  !mappers.isCustomUnit(ingredient.unite_mesure) &&
                  !mappers.isCustomUnit(
                    ingredientProduct.data.alternative_unite_mesure_production
                  )
                ) {
                  ingredient_quantity = this.$units(raw_ingredient_quantity)
                    .from(ingredient.unite_mesure)
                    .to(
                      ingredientProduct.data.alternative_unite_mesure_production
                    );
                }
              } else {
                if (
                  !mappers.isCustomUnit(ingredient.unite_mesure) &&
                  !mappers.isCustomUnit(ingredientProduct.data.unite_mesure)
                ) {
                  ingredient_quantity = this.$units(raw_ingredient_quantity)
                    .from(ingredient.unite_mesure)
                    .to(ingredientProduct.data.unite_mesure);
                }
              }
              ingredient_quantity = mappers.productProdToInv(
                ingredient_quantity,
                ingredientProduct.data,
                ingredient.is_alternative_unite_mesure
              );
            } else {
              if (
                !mappers.isCustomUnit(ingredient.unite_mesure) &&
                !mappers.isCustomUnit(
                  ingredientProduct.data.unite_mesure_inventory
                )
              ) {
                ingredient_quantity = this.$units(raw_ingredient_quantity)
                  .from(ingredient.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure_inventory);
              }
            }
            const product_record = this.getInventoryRecords.find(
              x => x.fk_product === ingredient.pk_recette_produit
            );
            let available = 0;
            if (product_record) {
              available = product_record.computedQuantity - ingredient_quantity;
            }
            requirements.requirements.push({
              product: ingredientProduct.nom,
              productId: ingredientProduct.id,
              productInvUnit: ingredientProduct.data.unite_mesure_inventory,
              require: ingredient_quantity,
              available: available
            });
          }
        });
      }
      let can_be_produce =
        !requirements.requirements.map(x => x.available).filter(x => x < 0)
          .length > 0;
      requirements.can_be_produce = can_be_produce;
      return requirements;
    },
    async getQuantityToProduce(item) {
      const qty = round10(item.quantity_asked + item.quantity_to_add - 2);
      item.quantity_to_produce = this.setQuantityToProduce(item);
      if (item.quantity_to_produce > 0) {
        const productionRequirements = await this.getItemProductionRequirements(
          item
        );
        item.can_be_produce = productionRequirements.can_be_produce;
        item.requirements = productionRequirements.requirements;
      }
      item.difference = round10(item.quantity_inventory - qty, -2);
    },
    getInventoryQuantity(id) {
      const record = this.getInventoryRecords.find(i => i.fk_product === id);
      if (record) {
        return round10(Number(record.computedQuantity), -2);
      } else {
        return 0;
      }
    }
  },
  watch: {
    preparationSlipTemplateId(newValue, oldValue) {
      if (newValue !== null && newValue !== oldValue) {
        const template = this.getPreparationSlipTemplates.find(
          x => x.id === newValue
        );
        this.preventSalesTrigger = true;
        this.showSalesTarget = template.sales_target !== null;
        if (this.getSaleEstimate === undefined) {
          this.sales_target_value =
            template.sales_target !== null
              ? Number(template.sales_target)
              : null;
        } else {
          this.sales_target_value = Number(this.getSaleEstimate.value);
        }

        this.preparationSlipTemplate = template;
        this.preventSalesTrigger = false;
      } else {
        if (this.sales_target_value !== Number(this.getSaleEstimate.value)) {
          this.sales_target_value = Number(this.getSaleEstimate.value);
        }
      }
    },
    sales_target_value() {
      if (this.preventSalesTrigger !== true) {
        this.preparationSlipTemplateHandler();
      }
    },
    preparationSlipTemplate: {
      deep: true,
      handler: "preparationSlipTemplateHandler"
    },
    async date(value, oldValue) {
      if (value !== oldValue) {
        await this.getData();
      }
    },
    timeValue(value, oldValue) {
      if (value !== oldValue) {
        this.setTemplateFromDefault();
      }
    }
  }
};
</script>

<style></style>
